export default __webpack_public_path__ + "static/media/style3.98dbd96d.jpeg";